import { TierBadge } from "@/components/funding/TierBadge";

export function GapPlan({ check }) {
  const gaps = check.requirements.filter((r) => check.gaps.includes(r.id));
  if (check.verdict === "ready") {
    return <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-5" data-testid="gap-plan-ready"><h3 className="font-semibold text-emerald-900">You meet every baseline requirement.</h3><p className="text-sm text-emerald-800 mt-1">Upload proof for each item to reach 100% verified, then build your Bank / SBA package.</p></div>;
  }
  return (
    <div data-testid="gap-plan">
      <h3 className="font-semibold text-slate-900">Your action plan · {gaps.length} item{gaps.length === 1 ? "" : "s"} to close</h3>
      <p className="text-sm text-slate-500">In order: owner credentials first, then federal, state and local requirements.</p>
      <ol className="mt-4 space-y-3">
        {gaps.map((r, i) => (
          <li key={r.id} className="bg-white border border-slate-200 rounded-lg p-4" data-testid={`gap-${r.id}`}>
            <div className="flex flex-wrap items-center gap-2"><span className="font-mono text-emerald-600 font-semibold">{String(i + 1).padStart(2, "0")}</span><TierBadge tier={r.tier} /><span className="font-semibold text-slate-900">{r.title}</span></div>
            <p className="text-sm text-slate-600 mt-1">{r.why}</p>
            <div className="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-2 text-xs text-slate-600">
              <div><span className="block font-mono text-[10px] uppercase text-slate-400">Who issues it</span>{r.issuer}</div>
              <div><span className="block font-mono text-[10px] uppercase text-slate-400">Typical cost</span>{r.typical_cost}</div>
              <div><span className="block font-mono text-[10px] uppercase text-slate-400">Typical time</span>{r.typical_timeline}</div>
            </div>
            <ul className="mt-2 list-decimal pl-5 text-sm text-slate-700 space-y-0.5">{(r.steps || []).map((s) => <li key={s}>{s}</li>)}</ul>
          </li>
        ))}
      </ol>
    </div>
  );
}
